import React from 'react';

// Centered pop-up shown the moment a task / lead / client is assigned to the
// signed-in user (or they're mentioned / asked to approve). Mounted globally by
// NotificationsProvider, so it appears on every page, not just the Dashboard.
export default function BellAlertModal({ notifications, onGotIt, onClose }) {
  return (
    <>
      <style>{`
        @keyframes modal-pop {
          0%   { opacity: 0; transform: translate(-50%, -50%) scale(0.85); }
          60%  { transform: translate(-50%, -50%) scale(1.03); }
          100% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
        }
        @keyframes backdrop-fade {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}</style>

      <div
        onClick={onClose}
        style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
          zIndex: 10000, animation: 'backdrop-fade 0.25s ease'
        }} />

      <div style={{
        position: 'fixed', top: '50%', left: '50%', zIndex: 10001,
        transform: 'translate(-50%, -50%)',
        animation: 'modal-pop 0.35s cubic-bezier(0.34,1.56,0.64,1) forwards',
        width: 380, maxWidth: '90vw',
        background: '#fff', borderRadius: 20,
        boxShadow: '0 32px 80px rgba(0,0,0,0.25)',
        overflow: 'hidden'
      }}>
        <div style={{ background: 'linear-gradient(135deg,#1d3461,#1f6feb)', padding: '28px 24px 20px', textAlign: 'center' }}>
          <div style={{ fontSize: 52, animation: 'bell-ring 0.7s ease-in-out 3', display: 'inline-block', lineHeight: 1 }}>🔔</div>
          <p style={{ color: '#fff', fontWeight: 700, fontSize: 18, marginTop: 10 }}>
            {notifications.every(n => n.type === 'task_mention') ? "You've Been Mentioned" : notifications.every(n => String(n.type).startsWith('followup_')) ? (notifications.some(n => n.type === 'followup_overdue') ? 'Missed Follow-up' : 'Follow-up Reminder') : 'New Notification'}
          </p>
          <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, marginTop: 4 }}>
            You have {notifications.length} new item{notifications.length > 1 ? 's' : ''} requiring your attention
          </p>
        </div>

        <div style={{ maxHeight: 240, overflowY: 'auto', padding: '12px 16px' }}>
          {notifications.slice(0, 5).map(n => (
            <div key={n.id} style={{
              padding: '10px 12px', borderRadius: 10, marginBottom: 8,
              background: '#f0f5ff', border: '1px solid #dbeafe'
            }}>
              <p style={{ fontWeight: 600, fontSize: 13, color: '#1e40af', marginBottom: 2 }}>{n.title}</p>
              {n.message && <p style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.4 }}>{n.message}</p>}
              <p style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>
                {new Date(n.created_at).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
              </p>
            </div>
          ))}
          {notifications.length > 5 && (
            <p style={{ textAlign: 'center', fontSize: 12, color: '#9ca3af' }}>
              +{notifications.length - 5} more notifications
            </p>
          )}
        </div>

        <div style={{ padding: '12px 24px 20px', borderTop: '1px solid #f3f4f6', display: 'flex', gap: 10 }}>
          <button
            onClick={onClose}
            style={{
              flex: 1, padding: '10px 0', borderRadius: 10, border: '1px solid #e5e7eb',
              background: '#f9fafb', color: '#6b7280', fontSize: 14, fontWeight: 500, cursor: 'pointer'
            }}>
            View Later
          </button>
          <button
            onClick={onGotIt}
            style={{
              flex: 2, padding: '10px 0', borderRadius: 10, border: 'none',
              background: 'linear-gradient(135deg,#1d3461,#1f6feb)',
              color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(31,111,235,0.4)'
            }}>
            ✓ Got it — Mark as Read
          </button>
        </div>
      </div>
    </>
  );
}
